export const CREDIT_CARD_METHOD = 'braintree'
export const PAYPAL_METHOD = 'paypalMethod'
export const PRZELEWY24_METHOD = 'przelewy24'
export const INVOICE_METHOD = 'invoice'

export const PAYPAL = 'paypal'

// CHECKOUT
export const CREDIT_CARD = 'credit_card'
export const PAYPAL_CHECKOUT = 'paypalMethod'
export const PRZELEWY24 = 'przelewy24'
export const INVOICE = 'invoice'

export type PaymentMethodTypes =
  | typeof CREDIT_CARD
  | typeof PAYPAL_CHECKOUT
  | typeof PRZELEWY24
  | typeof INVOICE
